<!--
 * @Author: your name
 * @Date: 2021-06-22 15:05:32
 * @LastEditTime: 2022-09-21 13:48:41
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrImage.vue
--> 
<!--图片-->

<template>
  <div class="attr-image">
    <div class="image-item flex-b-c">
      <span class="image-attr">{{$t('PE.Name')}}</span>
      <span class="ellipsis-1" :title="media.ext_val_name">{{media.ext_val_name}}</span>
    </div>
    <div class="image-item flex-b-c">
      <span class="image-attr">{{$t('PE.Scale')}}</span>
      <el-checkbox v-model="media.ext_val_scaleType">{{$t('PE.ConstrainProportions')}}</el-checkbox>
    </div>
    <div class="image-item flex-b-c">
      <span class="image-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="image-item flex-b-c">
      <span class="image-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="image-item flex-b-c">
      <span class="image-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
  import animations from '../../scripts/animations';
// const animations = [
//   { id: 'NONE', label: '无' },
//   { id: 'RANDOM', label: '随机' },
//   { id: 'BAI_YE_CHUANG', label: '百叶窗' },
//   { id: 'CA_CHU', label: '擦除' },
//   { id: 'HE_ZHUANG', label: '盒状' },
//   { id: 'JIE_TI', label: '阶梯' },
//   { id: 'LING_XING', label: '菱形' },
//   { id: 'LUN_ZI', label: '轮子' },
//   { id: 'PI_LIE', label: '劈裂' },
//   { id: 'QIE_RU', label: '切入' },
//   { id: 'QI_PAN', label: '棋盘' },
//   { id: 'SHAN_XIANG_ZHAN_KAI', label: '扇形展开' },
//   { id: 'SUI_JI_XIOAN_TIAO', label: '十字线条' },
//   { id: 'XIANG_NEI_RONG_JIE', label: '向内溶解' },
//   { id: 'YUAN_XING_KUO_ZHAN', label: '圆形扩展' }
// ];
export default {
  name: "AttrImage",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      animations,
    }
  },
  methods: {
    sizeChanged() {
      this.media.ext_val_size = this.media.ext_val_size + 1;
    }
  }
}
</script>

<style lang="scss" scoped>
.attr-image {
  padding-right: 4px;
  .image-item {
    min-height: 36px;
    margin: 8px 0px;
    .image-attr {
      font-family: 'Times New Roman';
      font-weight: normal;
      font-stretch: normal;
      color: #617883;
      min-width: 64px;
    }
  }
}
</style>
